// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from "react";
import MinusSquareOutlinedSvg from "@ant-design/icons-svg/lib/asn/MinusSquareOutlined";
import AntdIcon from "../components/AntdIcon";
const MinusSquareOutlined = (props, ref)=>/*#__PURE__*/ React.createElement(AntdIcon, {
        ...props,
        ref: ref,
        icon: MinusSquareOutlinedSvg
    });
if (process.env.NODE_ENV !== "production") {
    MinusSquareOutlined.displayName = "MinusSquareOutlined";
}
export default /*#__PURE__*/ React.forwardRef(MinusSquareOutlined);
